import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'retailer_portal-login_modal_logged_in_with_code-action_unknown';
/**
 * &#x2F;login-modal&#x2F;logged-in-with-code
 */
export function trackRetailerPortalLoginModalLoggedInWithCode() {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
    });
}
